import React from 'react';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import Grid from '@techsoftware/happay-widgets/Grid';
import { currencyFormatter } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import InvoiceBulkConfirmation from './InvoiceBulkConfirmation';

export default class InvoiceBulk extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bulkConfirmation: false,
      type: '',
    };
  }

  componentDidUpdate(prevProps) {
    const { invoiceBulkSuccess, invoiceBulkActionSuccess } = this.props;
    if (
      invoiceBulkSuccess &&
      prevProps.invoiceBulkSuccess !== invoiceBulkSuccess
    ) {
      this.setState({
        bulkConfirmation: false,
        type: '',
      });
      invoiceBulkActionSuccess(false)
    }
  }

  createBulkButton = isDisabled => {
    const { actions } = this.props;
    return actions.map(el => (
      <Icons
        id={el}
        type={el.toLowerCase()}
        size="large"
        className={`font-22 ${isDisabled ? 'body light icon-disabled' : ''}`}
        interactive
        tabIndex={0}
        tooltipText={
          isDisabled ? `A max. of 10 invoices can be ${el}d.` : `${el}`
        }
        tooltipClass="filter-tooltip hw-top"
        onClick={isDisabled ? () => {} : this.onClickAction}
      />
    ));
  };

  createParam = action => {
    const { selectedRows } = this.props;
    let obj = {};
    selectedRows.forEach(e => {
      obj[e.twf_id] = [{
        item_id: e['object_data.invoice_id'],
        action,
        approved_amount: e['object_data.approved_amount'],
      }];
    });
    return obj;
  };

  onClickAction = (event, otp) => {
    const { invoiceBulkAction } = this.props;
    const { type } = this.state;
    const id = event?.target?.id.split('-')[1] || '';
    if (['Approve', 'Decline'].includes(id)) {
      this.setState({
        bulkConfirmation: true,
        type: id,
      });
    } else if (otp) {
      invoiceBulkAction({
        bulk_map: JSON.stringify(this.createParam(type)),
        otp,
      });
    } else {
      invoiceBulkAction({
        bulk_map: JSON.stringify(this.createParam(type)),
      });
    }
  };

  checkForDifferentApprovalStatus = () => {
    const { selectedRows = [] } = this.props;
    const [firstElement] = selectedRows;
    const arr = firstElement?.['object_data.approval_status.name'];
    if (arr !== 'Pending') {
      return true;
    }
    for (let i = 0; i < selectedRows.length; i++) {
      if (selectedRows[i]['object_data.approval_status.name'] !== arr) {
        return true;
      }
    }
    return false;
  };

  getAmount = (el, key) => +el[`object_data.amount_breakdown.${key}`] || 0;

  returnInvoicesDetails = selectedRows => {
    let grossAmount = {
      grossPayable: 0,
      grossGST: 0,
      grossTDS: 0,
      grossDiscount: 0,
      grossBaseAmount: 0,
    };
    selectedRows.forEach(el => {
      const tax = this.getAmount(el, 'tax_amount');
      const tds = this.getAmount(el, 'tds_amount');
      const base = this.getAmount(el, 'base_amount');
      const discount = this.getAmount(el, 'discount');
      const totalPayable = +el['object_data.payable_amount'] || 0;
      grossAmount = {
        grossPayable: grossAmount['grossPayable'] + totalPayable,
        grossGST: grossAmount['grossGST'] + ((base - discount) * tax) / 100,
        grossTDS: grossAmount['grossTDS'] + ((base - discount) * tds) / 100,
        grossDiscount: grossAmount['grossDiscount'] + discount,
        grossBaseAmount: grossAmount['grossBaseAmount'] + base,
      };
    });
    return grossAmount;
  };

  render() {
    const { selectedRows = [], userInfo = {}, generateOTP } = this.props;

    const { bulkConfirmation, type } = this.state;

    if (selectedRows.length === 0) {
      return null;
    }

    const grossAmount = this.returnInvoicesDetails(selectedRows);
    const processingFeePercentage = userInfo.happay_processing_fee_percent?.replace(
      '%',
      '',
    );
    const processingFee =
      (grossAmount.grossPayable * +processingFeePercentage) / 100;

    const isDifferentApprovalStatus = this.checkForDifferentApprovalStatus();

    const isDisabled = selectedRows.length > 10;

    return (
      <Grid
        justify="space-between"
        className="padding-r-10 margin-r-10 pos-relative full-width d-flex"
        alignItems="center"
      >
        <div>
          <span className="font-12 margin-l-10 body">Invoices selected</span>
          <span className="font-16 fw-500 margin-l-6">
            {selectedRows.length}
          </span>
          <span className="font-16 fw-500 margin-l-30">
            <span className="font-12 margin-r-6 body">Total amount</span>
            {currencyFormatter(
              grossAmount.grossPayable,
              userInfo?.default_currency || 'INR',
            )}
          </span>
        </div>
        {isDifferentApprovalStatus ? null : (
          <div className="margin-t-7">
            {this.createBulkButton(isDisabled)}
            <hr />
          </div>
        )}
        {bulkConfirmation && (
          <InvoiceBulkConfirmation
            type={type}
            onClose={() => this.setState({ bulkConfirmation: false })}
            bulkInvoiceDetail={{
              ...grossAmount,
              finalAmount: grossAmount.grossPayable + processingFee,
              happayProcessingFee: processingFee,
              totalSelected: selectedRows.length,
            }}
            userInfo={userInfo}
            generateOTP={generateOTP}
            handleActionClick={otp => this.onClickAction(null, otp)}
          />
        )}
      </Grid>
    );
  }
}
